module.exports = __webpack_public_path__ + "img/KinokoTable38.cf6f7b1c.jpg";